export enum WimsListSort {
  default = 'default',
  last_updated = 'last_updated',
}

export type WimsPageFilterFormValues = {
  search: string;
};
